import { QuizAnswers } from "types/quiz";
import { useMemo } from "react";

const useQuizResults = <T extends { scoreRange: { min: number; max: number } }>(
  quizAnswers: QuizAnswers,
  results: T[],
) => {
  const totalScore = useMemo(
    () =>
      Object.values(quizAnswers).reduce(
        (sum, answer) =>
          sum + (answer?.answers.reduce((acc, ans) => acc + ans.score, 0) || 0),
        0,
      ),
    [quizAnswers],
  );

  const result = results.find(
    (result) =>
      totalScore >= result.scoreRange.min &&
      totalScore <= result.scoreRange.max,
  );

  return { totalScore, result };
};

export default useQuizResults;
